// [controllers] Include custom controllers here.

import Contracts from './controllers/Contracts';
import Property from './controllers/Property';
import Sor from './controllers/Sor';
import Equipment from './controllers/Equipment';
import  ServiveCategory from './controllers/ServiveCategory';
import  EquipmentStructure from './controllers/EquipmentStructure';
import  EquipmentBrand from './controllers/EquipmentBrand';
import  EquipmentModel from './controllers/EquipmentModel';
import  MaintenanceSchedule from './controllers/MaintenanceSchedule';
import  Runsheet from './controllers/Runsheet';
import  Organization from './controllers/Organization';
import  CheckListTemplate from './controllers/CheckListTemplate';
import  CheckList from './controllers/CheckList';
import  User from './controllers/User';
import  SorRecurringModes from './controllers/SorRecurringModes';
import  ContainerV2 from './controllers/ContainerV2';
import  Order from './controllers/Order';
import  Auth from './controllers/Auth';
import  Status from './controllers/Status'

import  V2Sor from './controllers/v2/Sor'
import  V2User from './controllers/v2/User'

import Job from './controllers/Job'
import EquipmentV2 from './controllers/v2/Equipment';
import SupplierEquipment from './controllers/v2/SupplierEquipment';
import CheckListTemplateV2 from './controllers/v2/CheckListTemplate';
import AccountSupplier from './controllers/v2/AccountSupplier'
import AllCompany from './controllers/v2/AllCompany'
import Role from './controllers/Role'
import Approval from './controllers/v2/Approval'
import Sla from './controllers/v2/Sla'
import PrioritySet from './controllers/v2/PrioritySet'
import ServiveCategoryMaster from './controllers/ServiveCategoryMaster'
import EquipmentStructureMaster from './controllers/EquipmentStructureMaster'
import OrderItem from './controllers/OrderItem';
import Address from './controllers/Address';
import GeneralLedger from './controllers/GeneralLedger';
import KpiTarget from './controllers/KpiTarget';
import IssueRegister from './controllers/IssueRegister';
import LiftInspectionReport from './controllers/LiftInspectionReport';
import OrderApprovalLog from './controllers/OrderApprovalLog';
import AppInvoice from './controllers/v2/AppInvoice';
import PaymentVoucher from './controllers/v2/PaymentVoucher';
import MasterGLAccount from './controllers/MasterGLAccount';
import ApInvoice from './controllers/ApInvoice';
import FmCode from './controllers/v2/FmCode';
import ChartOfAccount from './controllers/ChartOfAccount';
import GLAccount from  './controllers/v2/GLAccount';
import Employees from './controllers/Employees';
import PostingEntry from './controllers/v2/PostingEntry';
import DeliveryOrder from './controllers/v2/DeliveryOrder';
import MeteringDevices from './controllers/MeteringDevices';
import MeterReadingLog from './controllers/MeterReadingLog';
import AppVersion from './controllers/AppVersion';
import TaxVersioning from './controllers/TaxVersioning';
import VendorLinking from './controllers/VendorLinking';
import CaseManagement from './controllers/CaseManegement';
import NavisionFile from './controllers/NavisionFile';
import AppToken from './controllers/AppToken';
import AuditTrail from './controllers/AuditTrail';
import ImportLog from './controllers/ImportLog';
import MiscExpenses from './controllers/MicsExpenses';
import Reference from './controllers/Reference';
import ApprovalTemplate from './controllers/v2/ApprovalTemplate';
import ApprovalLinking from './controllers/v2/ApprovalLinking';
import PropertyDepartment from './controllers/PropertyDepartment';
import PropertyHeadLease from "./controllers/PropertyHeadLease";
import Attachment from './controllers/Attachment';
import ActivityLogs from './controllers/v2/ActivityLogs';
import WorkFolder from './controllers/WorkFolder';
import ManualPayTo from './controllers/ManualPayTo';
import UserDuty from './controllers/UserDuty';
import UserGroup from './controllers/UserGroup';
import NavisionSetting from './controllers/NavisionSetting';
import Tenants from './controllers/Tenants';
import TenantSite from './controllers/TenantSite';
import FaultType from './controllers/FaultType';
import LiquidatedDamages from './controllers/LiquidatedDamages';
import PartReplacement from './controllers/PartReplacement';
import UOB from './controllers/UOB';
import JobWorkFinding from './controllers/JobWorkFinding';
import AssetManagement from './controllers/AssetManagement';
import Purging from './controllers/Purging';
import MappingReport from './controllers/MappingReport';
import Attribute from './controllers/Attribute';
import AwaitingApproval from './controllers/AwaitingApproval';
import ERPMasterCodes from './controllers/ERPMasterCodes';
import BudgetAllocation from './controllers/BudgetAllocation';
import JobCalendar from './controllers/JobCalendar';
import PropertyVersioning from './controllers/PropertyVersioning';
import NotificationTemplate from './controllers/NotificationTemplate';
import CaseSettings from './controllers/CaseSettings';
import OperatingHourType from './controllers/OperatingHourType';
import OperatingHour from './controllers/OperatingHour';
import MaintenanceSettings from './controllers/MaintenanceSettings';
import EmailIntegration from './controllers/EmailIntegration';
import OldCaseManagement from './controllers/OldCaseManagement';
import Escalation from './controllers/Escalation';
import VendorLinkingCreditorCode from './controllers/VendorLinkingCreditorCode';
import FileDownload from './controllers/FileDownload';
import NLTCoveredSite from './controllers/NLTCoveredSite';
import JobIssueWorkFinding from './controllers/JobIssueWorkFinding';
import PerformanceAssesmentSettings from './controllers/PerformanceAssesmentSettings';
import PAConservancy from './controllers/v2/PAConservancy';
import AmazonConnect from './controllers/AmazonConnect';
import ContactSite from './controllers/v2/ContactSite';
import DashboardSixMonthlySafety from './controllers/DashboardSixMonthlySafety';
import DashboardV3Data from './controllers/DashboardV3Data';
import BatchSubmission from './controllers/BatchSubmission';
import LMUApprovalRequest from './controllers/LMUApprovalRequest';
import LMUDORJ from './controllers/LMUDORJ';
import NLTAddressBook from './controllers/NLTAddressBook';
import NLTReport from './controllers/NLTReport';
import LMUAddressBook from './controllers/LMUAddressBook';
import MasterBrand from './controllers/MasterBrand';
import ElectricityMeteringDevices from './controllers/ElectricityMeteringDevices';
import ElectricityMeterReadingLog from './controllers/ElectricityMeterReadingLog';
import OrderServiceReport from './controllers/OrderServiceReport';
import Garuda from './controllers/Garuda';
import CaseHotButton from './controllers/CaseHotButton';
import SContractProject from './controllers/SContractProject';
import OffsetDocument from './controllers/OffsetDocument';
import CreditNote from './controllers/CreditNote';
import NLTMailingList from './controllers/NLTMailingList';
import SafetyApp from './controllers/SafetyApp';
import SafetyAttachment from './controllers/SafetyAttachment';

// [init]

export default {

	modules: {
		ContractController : Contracts,
		PropertyController : Property,
		ServiveCategoryController : ServiveCategory,
		EquipmentStructureController : EquipmentStructure,
		MaintenanceScheduleController : MaintenanceSchedule,
		RunsheetController : Runsheet,
		OrganizationController : Organization,
		CheckListController : CheckList,
		SorRecurringModesController : SorRecurringModes,
		ContainerV2Controller : ContainerV2,
		OrderController : Order,
		AuthController : Auth,
		StatusController : Status,
		ServiveCategoryMasterController : ServiveCategoryMaster,
		EquipmentStructureMasterController : EquipmentStructureMaster,


		//V2
		v2SorController: V2Sor,
		JobController : Job,
		v2UserController : V2User,
		EquipmentV2Controller : EquipmentV2,
		SupplierEquipmentController : SupplierEquipment,
		v2CheckListTemplateController: CheckListTemplateV2,
		AccountSupplierController : AccountSupplier,
		AllCompanyController : AllCompany,
		RoleController : Role,
		v2SlaController: Sla,
		v2PrioritySetController: PrioritySet,
        OrderItemController: OrderItem,
		AddressController: Address,
		GeneralLedgerController : GeneralLedger,
		KpiTargetController : KpiTarget,
		ApprovalController: Approval,
		IssueRegisterController : IssueRegister,
		LiftInspectionReportController : LiftInspectionReport,
		OrderApprovalLogController : OrderApprovalLog,
		v2AppInvoiceController : AppInvoice,
		PaymentVoucherController: PaymentVoucher,
		MasterGLAccountController : MasterGLAccount,
		ApInvoiceController : ApInvoice,
		FmCodeController : FmCode,
		ChartOfAccountController : ChartOfAccount,
		GLAccountController: GLAccount,
		EmployeesController : Employees,
		PostingEntryController: PostingEntry,
		DeliveryOrderController: DeliveryOrder,
		MeteringDevicesController: MeteringDevices,
		MeterReadingLogController: MeterReadingLog,
		AppVersionController: AppVersion,
		TaxVersioningController: TaxVersioning,
		VendorLinkingController: VendorLinking,
		CaseManagementController: CaseManagement,
		NavisionFileController: NavisionFile,
		AppTokenController: AppToken,
		AuditTrailController: AuditTrail,
		ImportLogController: ImportLog,
		MiscExpensesController: MiscExpenses,
		ReferenceController: Reference,
		ApprovalTemplateController: ApprovalTemplate,
		ApprovalLinkingController: ApprovalLinking,
		PropertyDepartmentController: PropertyDepartment,
		PropertyHeadLeaseController: PropertyHeadLease,
		AttachmentController: Attachment,
		ActivityLogsController: ActivityLogs,
		WorkFolderController: WorkFolder,
		ManualPayToController: ManualPayTo,
		UserDutyController: UserDuty,
		UserGroupController: UserGroup,
		NavisionSettingController: NavisionSetting,
		TenantsController: Tenants,
		TenantSiteController: TenantSite,
		FaultTypeController: FaultType,
		LiquidatedDamagesController: LiquidatedDamages,
		PartReplacementController: PartReplacement,
		UOBController: UOB,
		JobWorkFindingController: JobWorkFinding,
		AssetManagementController: AssetManagement,
		PurgingController: Purging,
		MappingReportController: MappingReport,
		AttributeController: Attribute,
		AwaitingApprovalController: AwaitingApproval,
		ERPMasterCodeController: ERPMasterCodes,
		BudgetAllocationController: BudgetAllocation,
		JobCalendarController: JobCalendar,
		PropertyVersioningController: PropertyVersioning,
		NotificationTemplateController: NotificationTemplate,
		CaseSettingsController: CaseSettings,
		OperatingHourController: OperatingHour,
		OperatingHourTypeController: OperatingHourType,
		MaintenanceSettingsController: MaintenanceSettings,
		EmailIntegrationController : EmailIntegration,
		OldCaseManagementController: OldCaseManagement,
		EscalationController: Escalation,
        VendorLinkingCreditorCodeController : VendorLinkingCreditorCode,
		FileDownloadController: FileDownload,
		NLTCoveredSiteController: NLTCoveredSite,
		JobIssueWorkFindingController: JobIssueWorkFinding,
		PerformanceAssesmentSettingsController: PerformanceAssesmentSettings,
		PAConservancyController: PAConservancy,
		AmazonConnectController: AmazonConnect,
		ContactSiteController: ContactSite,
		DashboardSixMonthlySafetyController: DashboardSixMonthlySafety,
		DashboardV3Controller: DashboardV3Data,
		BatchSubmissionController: BatchSubmission,
		LMUApprovalRequestController: LMUApprovalRequest,
		LMUDORJController: LMUDORJ,
        NLTAddressBookController: NLTAddressBook,
        NLTReportController: NLTReport,
        LMUAddressBookController: LMUAddressBook,
        MasterBrandController: MasterBrand,
        ElectricityMeteringDevicesController: ElectricityMeteringDevices,
		ElectricityMeterReadingLogController: ElectricityMeterReadingLog,
		OrderServiceReportController: OrderServiceReport,
		GarudaController: Garuda,
		CaseHotButtonController: CaseHotButton,
		SContractProjectController: SContractProject,
		OffsetDocumentController: OffsetDocument,
		CreditNoteController: CreditNote,
		NLTMailingListController: NLTMailingList,
		SafetyAppController: SafetyApp,
		SafetyAttachmentController: SafetyAttachment,
	}
};
